import { type PropsWithChildren } from 'react';

import { AnalyticsContext } from './AnalyticsContext';
import type { AnalyticsInterface } from './services';

interface AnalyticsProviderProps {
  analytics: AnalyticsInterface;
}

export const AnalyticsProvider = ({ children, analytics }: Readonly<PropsWithChildren<AnalyticsProviderProps>>) => {
  return <AnalyticsContext.Provider value={analytics}>{children}</AnalyticsContext.Provider>;
};
